export function sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }



// WEBPACK FOOTER //
// ./src/utils.js